if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButtons = this.form.querySelectorAll('[type="submit"]');

        if (document.querySelector('cart-drawer')) {
          this.submitButtons.forEach(submitButton => {
            submitButton.setAttribute('aria-haspopup', 'dialog');
          });
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButtons[0].getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButtons.forEach(submitButton => {
          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');
        });

        // Dispatch saved cart item event for customer accounts
        const gwCustomerAccounts = document.querySelector('gw-customer-accounts');
        if (gwCustomerAccounts) {
          const event = new CustomEvent('gw:saved-items-from-cart', {
            detail: {
              productId: this.form.querySelector('[name="product-id"]').value,
              variantId: this.form.querySelector('[name="id"]').value,
              target: this.form,
            },
          });

          gwCustomerAccounts.dispatchEvent(event);
        }

        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map(section => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        if (!!this.submitButtons[0].dataset.shippingDate) {
          formData.append('properties[Pre-order]', true);
          formData.append(
            'properties[Estimated shipping date]',
            this.submitButtons[0].dataset.shippingDate
          );
        }
        if (!!this.submitButtons[0].dataset.mto) {
          formData.append(
            'properties[Made to order]',
            this.submitButtons[0].dataset.mto
          );
        }
        if (this.submitButtons[0].dataset.finalSale === 'true') {
          formData.append('properties[Final sale]', true);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then(response => response.json())
          .then(response => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              this.submitButtons.forEach(submitButton => {
                const soldOutMessage = this.submitButtons[0].querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                submitButton.setAttribute('aria-disabled', true);
                submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
              });

              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }

            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
            this.error = false;
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');

            this.submitButtons.forEach(submitButton => {
              submitButton.classList.remove('loading');
              if (!this.error) submitButton.removeAttribute('aria-disabled');
            });
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          const allInCartPattern = /^All\s.*\sin\syour\scart.$/;

          if (allInCartPattern.test(errorMessage)) {
            this.errorMessage.textContent = window.cartStrings.allInCartError;
          } else {
            this.errorMessage.textContent = errorMessage;
          }
        }
      }
    }
  );
}
